<era-master-detail flexGrowLeft="2"
                   flexGrowRight="3">
  <era-master>
    <era-panel>
      <era-panel-header>
        <era-title>
          <span title
                i18n>Users</span>
          <era-context-menu [isEditing]="editEnabled()"
                            (selectedEdit)="toggleEdit()"
                            canEdit="true">
            <button ngbDropdownItem
                    (click)="addUser()">Add user</button>
          </era-context-menu>
        </era-title>
        <div class="border-bottom"></div>
      </era-panel-header>
      <div class="list-group list-group-flush">
        @for (user of users(); track user) {
          <era-security-user-list-item [isEditing]="editEnabled()"
                                       [user]="user"></era-security-user-list-item>
        }
      </div>
    </era-panel>
  </era-master>
</era-master-detail>